import React from 'react';
import { navigate } from 'gatsby';
import useRunOnce from '$/hooks/useRunOnce';

export const Redirect: React.FC<{ to: string }> = ({ to }) => {
  useRunOnce(() => {
    navigate(to);
  });

  return null;
};
